import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Client } from '../models/client';
import { User } from '../models/user';
import { ApplicationService } from './application.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public url: string;
  public user: any;
  public token: string;
  public is_logged_in: boolean;
  public client: any;

  constructor(
    private _http: HttpClient,
    private router: Router,
    private applicationService: ApplicationService
  ) {
    this.url= environment.url;
    this.meSesion();
   }
  login(user): Observable<any> {
    const parans = JSON.stringify(user);
    const headers = new HttpHeaders();
    return this._http.post(this.url + '/auth/login', parans, { headers });
  }
  me():Observable<any>{
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + '/auth/me', { headers });  
  }
  saveToken(token){
    localStorage.setItem('token', token);
  }
  meSesion(){
    if (localStorage.getItem('token')){
      this.is_logged_in=true;
      this.token=localStorage.getItem('token');
    }
    if (localStorage.getItem('user')){
      this.user= JSON.parse(localStorage.getItem('user'));
      return 
    }
    this.is_logged_in=false;
    this.user=undefined;
    this.token='';

  }
 
  getToken() {
    if (this.token!=undefined ) {
      return this.token;
    }
    this.token = '';
  }

  logOut(){
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    this.token='';
    this.user=undefined;
    this.router.navigate(['/login']);
    this.client=undefined;
    this.applicationService.apps=[];
  }

  recoveryPassword(email): Observable<any> {
    const parans = JSON.stringify(email);
    const headers = new HttpHeaders();
    return this._http.post(this.url + '/public/client-password-recover', email, { headers });
  }

  changePassword(body):Observable<any>{
    const parans = JSON.stringify(body);
    const headers = new HttpHeaders();
    return this._http.put(this.url + '/users/update_password', parans, { headers });
  }

  getClientById(id:string):Observable<Client>{
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get<Client>(this.url + '/users?id='+id, { headers });
  }
  getUsers():Observable<User[]>{
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get<User[]>(this.url + '/users', { headers });
  }
  updateUser(body):Observable<any>{
    const parans = JSON.stringify(body);
    const headers = new HttpHeaders();
    return this._http.put(this.url + '/users', parans, { headers });
  }
  postUser(body):Observable<any>{
    const parans = JSON.stringify(body);
    const headers = new HttpHeaders();
    return this._http.put(this.url + '/users', parans, { headers });
  }
}
